import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Main = styled.main`
  flex-grow: 1;
`;

export const NotFoundSection = styled.section`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100vh;
`;

export const Title = styled.h1`
  ${typographyV2.titleXL};
`;

export const Description = styled.p`
  ${typographyV2.bodyMd};
`;

export const AnimationContainer = styled.div`
  width: 240px;
  height: 180px;
  display: flex;
  justify-self: center;
`;
